import { Tag } from "@/schema"
import { ComboboxInput } from "@ui/forms/inputs/combobox-input"

import { EntityLabelSelector } from "@/components/shared/entity-label-selector"

interface OpportunityLabelSelectorProps {
  label: Tag | null
  onLabelChange: (label: Tag | null) => void
  triggerButton?: React.ReactNode
  disabled?: boolean
  contentProps?: React.ComponentPropsWithoutRef<typeof ComboboxInput>["contentProps"]
  className?: string
}

export function OpportunityLabelSelector(props: OpportunityLabelSelectorProps) {
  return <EntityLabelSelector entityType="opportunity" {...props} />
}
